// Use throughout your app instead of plain `useDispatch` and `useSelector`
import isBrowser from '../utils/isBrowser'

declare global {
  interface Window {
    __quincePubSubMap: Record<string, any>
  }
}

export default class PubSub {
  subscribers: Record<symbol, () => void> = {}

  /**
   * Note: Here in static, if child is calling getInstance, then this contains child info.
   */
  static getInstance(pubSubKey: string) {
    if (isBrowser()) {
      window.__quincePubSubMap = window.__quincePubSubMap || {}
      window.__quincePubSubMap[pubSubKey] = window.__quincePubSubMap[pubSubKey] || new this()
      return window.__quincePubSubMap[pubSubKey]
    }
    return new this()
  }

  publish() {
    const symbols = Object.getOwnPropertySymbols(this.subscribers)
    symbols.forEach(symbol => {
      this.subscribers[symbol]()
    })
  }

  subscribe(callback: () => void) {
    const subscriberId = Symbol()
    this.subscribers[subscriberId] = callback
    callback()
    return () => {
      delete this.subscribers[subscriberId]
    }
  }
}
